import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ApplicationInputStyle,
  Color,
  Inputs,
  SurveyButtonStyle,
  applyMaxLengths,
} from "../../constants";
import ApplyRequiredError from "./ApplyRequiredError";
import { updateAppData } from "../../utils/actionUtils";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import FettiInput from "../FettiInput";
import SimpleApplyField from "./SimpleApplyField";
import ApplyLocationAutocomplete from "./ApplyLocationAutocomplete";
import { valueToPhoneNumber } from "../../utils/utils";
import FettiFileUpload from "../FettiFileUpload";
import FettiSelect from "../FettiSelect";
import * as apiService from "../../service/ApiService";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ResumeSelect from "./ResumeSelect";
import NewResumeButton from "./NewResumeButton";
import ResumeFloatPreview from "../ResumeFloatPreview";
import PreviewResumeButton from "./PreviewResumeButton";

// resume upload panel during applying process
const ResumeApply = () => {
  const dispatch = useDispatch();
  const apply = useSelector((state) => state.apply);
  const appData = useSelector((state) => state.apply.app);
  const auth = useSelector((state) => state.auth);
  const [file, setFile] = React.useState({
    data: null,
    name: "",
    size: 0,
  });
  const [uploadName, setUploadName] = React.useState("");
  const [userOpenedUploadUI, setUserOpenedUploadUI] = React.useState(false);
  const [showPreviewFloat, setShowPreviewFloat] = React.useState(false);
  const showUploadUI =
    userOpenedUploadUI || apply.serverData.resumes.length === 0;
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    if (file.data && file.name) {
      setUploadName(file.name.split(".")[0]);
    }
  }, [file]);
  const handleUpload = () => {
    const fileName = uploadName;
    const filePath = file.name;
    const fileData = file.data;
    setLoading(true);
    apiService.uploadResume(
      dispatch,
      {
        ...auth.accountData,
        fileName,
        filePath,
        fileData,
      },
      {
        handleFinish: () => {
          setLoading(false);
          // setFile({
          //   data: null,
          //   name: "",
          //   size: 0,
          // });
          // setUploadName("");
        },
        handleSuccess: () => {
          setFile({
            data: null,
            name: "",
            size: 0,
          });
          setUploadName("");
          setUserOpenedUploadUI(false);
        },
      }
    );
  };

  return (
    <>
      <Box sx={ApplicationInputStyle.categoryLabel}>
        Upload a resume for the employer
      </Box>
      {/* Select from uploaded resumes */}
      {apply.serverData.resumes.length > 0 && (
        <>
          <Stack direction="column" sx={{ width: "100%" }} spacing={1}>
            <ResumeSelect />
            {!showUploadUI && (
              <Stack direction="row" spacing={2}>
                <NewResumeButton setOpen={setUserOpenedUploadUI} />
                {appData.resume && (
                  <>
                    <PreviewResumeButton setOpen={setShowPreviewFloat} />
                    <ResumeFloatPreview
                      show={showPreviewFloat}
                      handleClose={() => setShowPreviewFloat(false)}
                      resumeId={appData.resume[0]}
                      fileType={appData.resume[2]}
                    />
                  </>
                )}
              </Stack>
            )}
          </Stack>
        </>
      )}
      {/* Upload new resume */}
      {showUploadUI && (
        <>
          <FettiFileUpload
            file={file}
            setFile={setFile}
            label="Resume"
            canClose={apply.serverData.resumes.length > 0}
            onClose={() => setUserOpenedUploadUI(false)}
          />
          {file.data && (
            <Stack direction="column" spacing={1}>
              <Box sx={ApplicationInputStyle.header}>
                Name your resume (for your reference)
              </Box>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Stack
                  {...ApplicationInputStyle.stackProps}
                  sx={ApplicationInputStyle.stack}>
                  <FettiInput
                    value={uploadName}
                    placeholder="Resume (Full-Stack Developer)"
                    onChange={(v) => setUploadName(v.target.value)}
                    maxLength={50}
                  />
                </Stack>
                <Button
                  sx={{
                    ...SurveyButtonStyle.defaultStyling,
                    ...SurveyButtonStyle.blueOutline,
                    borderRadius: Inputs.borderRadius,
                    width: "100px",
                    minWidth: "100px",
                    height: "39px",
                  }}
                  disableRipple
                  fullWidth
                  onClick={handleUpload}
                  disabled={loading}>
                  {loading ? <CircularProgress size="20px" /> : "Upload"}
                </Button>
              </Stack>
            </Stack>
          )}
        </>
      )}
    </>
  );
};

export default ResumeApply;
